<template>
  <div id="data-list-list-view" class="data-list-container m-5">
    <vs-alert :color="response.AlertColor" :title="response.Title"
      :active.sync="response.StatusCode != 200 && response.StatusCode != null">
      <span>{{ response.Body }} </span>
    </vs-alert>

    <div v-if="response.StatusCode == 200">

      <div class="vx-col lg:w-3/4" style="margin:auto">
        <vx-card v-if="response.Data.CourseClass">
          <h3 style="text-align: center">{{ $t('TrainingOrderNumber') }} {{ response.Data.CourseClass.ClassNo }}</h3>
          <h3 style="text-align: center"> {{ response.Data.CourseClass.Course.Name }} </h3>
          <h4 style="text-align: center"> {{ $t('From') }} {{ response.Data.CourseClass.StartDate.split('T')[0] }}
            {{ $t('To') }} {{ response.Data.CourseClass.EndDate.split('T')[0] }}</h4>
          <br>
          <p style="text-align: center" v-html="response.Data.Title"></p>

        </vx-card>
        <vx-card title="Keys" class="mt-5">
          <div class="vx-row">
            <img alt="" class="ml-10 mr-2" :src="DownUrl + '/uploads/Feedback_Excellent.png'" /> {{ $t('Excellent') }}
            <img alt="" class="ml-10 mr-2" :src="DownUrl + '/uploads/Feedback_Good.png'" /> {{ $t('Good') }}
            <img alt="" class="ml-10 mr-2" :src="DownUrl + '/uploads/Feedback_Fair.png'" /> {{ $t('Fair') }}
            <img alt="" class="ml-10 mr-2" :src="DownUrl + '/uploads/Feedback_Poor.png'" /> {{ $t('Poor') }}
            <img alt="" class="ml-10 mr-2" :src="DownUrl + '/uploads/Feedback_Very poor.png'" /> {{ $t('VeryPoor') }}
          </div>
        </vx-card>

        <vx-card v-for="cat in response.Data.CategoryAssessments" :key="cat.ID" class="p-5 mt-5">
          <div class="vx-row">
            <img alt="" :src="DownUrl + cat.IconUrl" style="width:40px" />
            <h2 class="mt-5 ml-5">{{ cat.Name }}</h2>
          </div>
          <div class="p-5" v-for="(item, index) in cat.CustomerReviewQuestions" :key="index">
            <div class="vx-row">
              <label class="mt-3 pl-3 vx-col">{{ item.QuestionText }}</label>

              <vs-checkbox class="mt-2" v-if="item.QuestionTypeID == 2" v-model="item.Answer"></vs-checkbox>
            </div>

            <div v-if="item.QuestionTypeID == 4" class="vx-row ml-5">
              <div v-for="Ans in item.CustomerReviewAnswers" :key="Ans.ID" class="mt-2">
                <vs-radio v-model="item.Answer" class="face" :vs-name="item.QuestionText" :vs-value="Ans.ID">
                  <img alt=""
                    :style="{ 'filter': item.Answer != Ans.ID ? 'opacity(75%)' : 'opacity(100%)', 'width': item.Answer != Ans.ID ? '45px' : '65px' }"
                    :src="DownUrl + Ans.Icon" />
                </vs-radio>
              </div>
            </div>

            <div v-if="item.QuestionTypeID == 5" class="vx-row">
              <div v-for="(Ans, count) in item.CustomerReviewAnswers" :key="Ans.ID" class="mt-2">
                <vs-radio v-model="item.Answer" class="face" :vs-name="item.QuestionText" :vs-value="Ans.ID"><span
                    :style="{ 'filter': item.Answer != Ans.ID ? 'opacity(80%)' : 'opacity(100%)', 'font-size': item.Answer != Ans.ID ? '45px' : '65px' }">[{{
                      count + 1 }}]</span></vs-radio>
              </div>
            </div>

            <div class="mt-5 ml-5" v-if="item.QuestionTypeID == 3">
              <div v-for="Ans in item.CustomerReviewAnswers" :key="Ans.ID">
                <vs-radio v-model="item.Answer" :vs-name="item.QuestionText" :vs-value="Ans.ID">{{ Ans.AnswerText
                }}</vs-radio>
              </div>
            </div>



            <div class="pl-5" v-if="item.QuestionTypeID == 1">
              <vs-textarea class="w-full" v-model="item.Answer"></vs-textarea>
            </div>
          </div>
        </vx-card>
        <vx-card class="mt-5 items-center">
          <h5 style="text-align: center">{{ $t('ThankFeadBack') }}</h5>
        </vx-card>
      </div>
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <!-- :disabled="!isFormValid" -->
          <vs-button class="mr-6" @click="submitReview">{{ $t('Submit') }}</vs-button>
          <vs-button type="border" color="danger" :to="{ name: 'AvailableReview' }">{{ $t('Back') }}</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moduleCourseReview from "@/store/customerReview/courseReview/moduleCourseReview.js";
import moduleAssessmentResult from "@/store/customerReview/assessmentResult/moduleAssessmentResult.js";
import { domain } from '@/gloabelConstant.js'
export default {
  data() {
    return {
      response: {},
      DownUrl: domain,
    }
  },
  computed: {
    isFormValid() {
      var valid = true;
      this.response.Data.CategoryAssessments.forEach(category => {
        category.CustomerReviewQuestions.forEach(question => {
          if (!question.Answer)
            valid = false
        })
      });

      return valid;
    }
  },
  methods: {
    submitReview() {
      this.$vs.loading();
      this.$store.dispatch('AssessmentResultList/SubmitTraineeReviewResult',
        this.response.Data).then(() => {
          this.$vs.loading.close();
          debugger
          this.response.StatusCode = 201;
          this.response.Body = "Review submited successfully";
          this.response.AlertColor = "success";
          this.response.Title = "Successfully";
        }).catch(() => {
          debugger
          this.$vs.loading.close();
          debugger
          this.response.StatusCode = 404;
          this.response.Body = "Unexpected error";
          this.response.AlertColor = "danger";
          this.response.Title = "Error";
        })
        debugger
    }
  },
  created() {

    if (!moduleCourseReview.isRegistered) {
      this.$store.registerModule("CourseReviewList", moduleCourseReview);
      moduleCourseReview.isRegistered = true;
    }

    if (!moduleAssessmentResult.isRegistered) {
      this.$store.registerModule("AssessmentResultList", moduleAssessmentResult);
      moduleAssessmentResult.isRegistered = true;
    }

    const Code = this.$route.params.Code

    if (Code != undefined) {
      var data = {};
      data.Code = Code;
      data.AssessmentTypeID = 2;
      this.$vs.loading();
      this.$store.dispatch("CourseReviewList/getCourseReviewByCode", data)
        .then(res => {
          this.$vs.loading.close();
          this.response = res.data;
        })
        .catch(() => {
          this.$vs.loading.close();
          this.response.StatusCode = 404;
          this.response.Body = "Unexpected error";
          this.response.AlertColor = "danger";
          this.response.Title = "Error";
        })
    }
  }
}
</script>
<style>
.face .vs-radio .vs-radio--circle {
  display: none;
}

.face .vs-radio .vs-radio--borde {
  display: none;
}
</style>
